<template>
  <vs-tabs>
    <vs-tab :label="$t('default_settings')">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('name')" :placeholder="$t('name')" v-model="userFormData.name" class="w-full"/>
            <validation-error :model-error="userFormErrors.name"></validation-error>
          </div>
        </div>

        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('id')" :placeholder="$t('id')" v-model="userFormData.username" class="w-full"/>
            <validation-error :model-error="userFormErrors.username"></validation-error>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <label class="vs-input--label" v-text="$tc('department')"></label>
            <v-select :options="departments" :reduce="label => label.value" :placeholder="$t('assigned_to')" v-model="userFormData.department_id" class="md:mb-0">
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <span  v-text="$t('v_select_add_an_agent_belonging_to_the_environment_setting')"></span>
                </template>
              </template>
            </v-select>
            <validation-error :model-error="userFormErrors.department_id"></validation-error>
          </div>
        </div>

        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input type="password" :label="$t('password')" :placeholder="$t('password')" v-model="userFormData.password" class="w-full"/>
            <validation-error :model-error="userFormErrors.password"></validation-error>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <label class="vs-input--label" v-text="$t('assigned_extension')"></label>
            <v-select :options="unusedExtensions" :reduce="label => label.value" :placeholder="$t('assigned_extension')" v-model="userFormData.extension_id" class="md:mb-0" />
            <validation-error :model-error="userFormErrors.extension_id"></validation-error>
          </div>
        </div>

        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input type="password" :label="$t('password_confirmation')" :placeholder="$t('password_confirmation')" v-model="userFormData.password_confirmation" class="w-full"/>
            <validation-error :model-error="userFormErrors.password_confirmation"></validation-error>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('cordless_phone')" :placeholder="$t('cordless_phone')" v-model="userFormData.landline" class="w-full"/>
            <validation-error :model-error="userFormErrors.landline"></validation-error>
          </div>
        </div>

        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('wireline')" :placeholder="$t('wireline')" v-model="userFormData.mobile" class="w-full"/>
            <validation-error :model-error="userFormErrors.mobile"></validation-error>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('time_in_schedule')" v-model="userFormData.time_in_schedule" type="time" class="w-full"/>
            <validation-error :model-error="userFormErrors.time_in_schedule"></validation-error>
          </div>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('time_out_schedule')" v-model="userFormData.time_out_schedule" type="time" class="w-full"/>
            <validation-error :model-error="userFormErrors.time_out_schedule"></validation-error>
          </div>
        </div>

      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('context')" :placeholder="$t('context')" v-model="userFormData.context" class="w-full"/>
            <validation-error :model-error="userFormErrors.context"></validation-error>
          </div>
        </div>

        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
        </div>
      </div>
    </vs-tab>

    <vs-tab :label="$t('cti_functions')">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-checkbox v-model="userFormData.dial" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-dial"></i>
            </vs-button>

            <span class="ml-4" v-text="$t('dial')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.blindtransfer" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-blind-transfer"></i>
            </vs-button>

            <span class="ml-4" v-text="$t('blind_transfer')"></span>
          </vs-checkbox>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-checkbox v-model="userFormData.attendedtransfer" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-attended-transfer"></i>
            </vs-button>

            <span class="ml-4" v-text="$t('attended_transfer')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.transfer" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-transfer"></i>
            </vs-button>

            <span class="ml-4" v-text="$tc('transfer')"></span>
          </vs-checkbox>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-checkbox v-model="userFormData.listen" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-listen"></i>
            </vs-button>

            <span class="ml-4" v-text="$t('listen')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.whisper" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-whisper"></i>
            </vs-button>

            <span class="ml-4" v-text="$t('whisper')"></span>
          </vs-checkbox>
        </div>
      </div>
    </vs-tab>

    <vs-tab :label="$t('menu_functions')">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-checkbox v-model="userFormData.dashboard_stat" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('dashboard_stat')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.menu_queue_status" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('menu_queue_status')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.manage_users" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('manage_users')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.configurations" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('configuration')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.sms" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('sms')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.dashboard" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('dashboard')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.members" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('members')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.tasks" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('tasks')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.message_management" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('message_management')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.menu_schedules" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('menu_schedules')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.branch_extension" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('branch_extension')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.extension_status_data_analysis" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('extension_status_data_analysis')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="userFormData.blacklist" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('blacklist')"></span>
          </vs-checkbox>
        </div>

        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-checkbox v-model="userFormData.fax" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('permission_fax')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.set_working_hours" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('set_working_hours')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.recording_manager" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('recording_manager')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.agent_analytics" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('agent_analytics')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.inbound_details" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('inbound_details')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="userFormData.outbound_details" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('outbound_details')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="userFormData.inbound_statistics" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('inbound_statistics')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="userFormData.call_statistics" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('call_statistics')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.consultations" class="mt-3 mb-3">
            <span class="ml-4" v-text="$tc('consultation', 2)"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.my_account" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('my_account')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.projects" class="mt-3 mb-3">
            <span class="ml-4" v-text="$tc('project', 2)"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.slogan" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('slogan')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.upload_sound_file" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('upload_sound_file')"></span>
          </vs-checkbox>

        </div>
      </div>
    </vs-tab>

    <vs-tab :label="$t('sub_functions')">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-checkbox v-model="userFormData.call_list" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('call_list')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.call_back" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('call_back')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userFormData.cti_new_window" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('cti_new_window')"></span>
          </vs-checkbox>
        </div>
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import { EventBus } from '@/../eventbus'
import Users from '@/models/User'

export default {
  name: 'Shared.User.Add',
  props: {
    departments: {
      type: Array,
      required: true
    },
    unusedExtensions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      userFormData: {
        id: '',
        name: '',
        username: '',
        password: '',
        context: '',
        time_in_schedule: '',
        time_out_schedule: '',
        is_active: '',
        landline: '',
        mobile: '',
        department_id: '',
        extension_id: '',

        dial: true,
        blindtransfer: true,
        attendedtransfer: true,
        transfer: true,
        listen: false,
        whisper: false,
        dashboard_stat: false,
        menu_queue_status: false,
        manage_users: false,
        configurations: false,
        sms: false,
        fax: false,
        set_working_hours: false,
        recording_manager: false,
        agent_analytics: false,
        inbound_details: false,
        outbound_details: false,
        inbound_statistics: false,
        call_statistics: false,
        call_list: false,
        call_back: false,
        cti_new_window: true,
        dashboard: true,
        consultations: true,
        members: true,
        my_account: true,
        tasks: false,
        projects: false,
        message_managent: false,
        menu_schedules: false,
        slogan: false,
        branch_extension: false,
        extension_status_data_analysis: false,
        blacklist: false
      },
      userFormErrors: {}
    }
  },
  mounted () {
    this.initUserFormData()
    EventBus.$on('registerUser', this.submit)
    EventBus.$on('initUserFormData', this.initUserFormData)
  },
  methods: {
    async submit () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addUserButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          const response = await Users.save(this.userFormData) // TODO: Handle Response
          this.$store.dispatch('setIsFormInProgress', false)

          this.$emit('registerUserSuccess', response)

          this.userFormErrors = {}
          this.initUserFormData()
        }
      } catch (e) {
        const originalErrors = e.response.data.errors
        const updatedErrors = {}
        for (const key in originalErrors) {
          updatedErrors[key] = []
          updatedErrors[key].push(`${this.$t(originalErrors[key][0])}`)
        }
        this.userFormErrors = updatedErrors
        // console.log(updatedErrors, e.response.data.errors)
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#addUserButton > .con-vs-loading')
    },

    initUserFormData () {
      this.userFormData = {
        id: '',
        name: '',
        username: '',
        password: '',
        context: '',
        time_in_schedule: '',
        time_out_schedule: '',
        is_active: '',
        landline: '',
        mobile: '',
        department_id: '',
        extension_id: '',

        dial: true,
        blindtransfer: true,
        attendedtransfer: true,
        transfer: true,
        listen: false,
        whisper: false,
        dashboard_stat: false,
        menu_queue_status: false,
        manage_users: false,
        configurations: false,
        sms: false,
        fax: false,
        set_working_hours: false,
        recording_manager: false,
        agent_analytics: false,
        inbound_details: false,
        outbound_details: false,
        inbound_statistics: false,
        call_statistics: false,
        call_list: false,
        call_back: false,
        cti_new_window: true,
        dashboard: true,
        consultations: true,
        members: true,
        my_account: true,
        tasks: false,
        projects: false,
        message_managent: false,
        menu_schedules: false,
        slogan: false,
        branch_extension: false,
        extension_status_data_analysis: false,
        blacklist: false
      }
      this.userFormErrors = {}
    }
  }
}
</script>

<style lang="scss">
  #addUserButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
